import { render, staticRenderFns } from "./company-add.vue?vue&type=template&id=377f52d1&scoped=true"
import script from "./company-add.vue?vue&type=script&lang=js"
export * from "./company-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f52d1",
  null
  
)

export default component.exports